const initialState = {messages: [], players: [], scroll: 'bottom', limit: 10}

const firestoreChannel = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'FIRESTORE_CHANNEL.RECEIVED':
      return {...state, messages: payload.messages, players: payload.players}
    case 'FIRESTORE_CHANNEL.SET_SCROLL_AND_LIMIT':
      return {...state, scroll: payload.scroll, limit: payload.limit}
    case 'FIRESTORE_CHANNEL.CLOSE':
      return {...state, messages: [], players: []}
    default:
      return state
  }
}

export default firestoreChannel
